let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dL4hn")).then(() => parcelRequire('7blzH'));